import { HasAppAccessPrivateLayout } from '@ztechapps/webui.page'
import { quickscorePermissions } from '@ztechapps/quickscore.common'
import { Header } from './components/Header'

const hasAppAccessPermission = quickscorePermissions.quickscoreAdmin.canAccess.value

// Route element for every `/app/*` screen — gates on the QuickScore-admin access
// permission, then renders the top-navbar shell around the routed page via
// HasAppAccessPrivateLayout's <Outlet/>. No sidebar — full-width content only.
export default function MainLayout() {
  return <HasAppAccessPrivateLayout hasAppAccessPermission={hasAppAccessPermission} header={<Header />} />
}
